import { HttpClient } from '@angular/common/http';
import { onErrorCallbackInterface } from '../interfaces/interfaces';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Url } from '../constants/url';
import { Company, CompanyIgnoreList } from '../models/company.model';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})

export class CompanyService extends GenericBaseService {


  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Company', httpClient, toastrService, url);
  }

  postCompany(company: Company, afterPostCallback?: Function, customMessage?: string, onErrorCallback?: onErrorCallbackInterface): void {
    return this.postNow('/company', this.getBody(company, CompanyIgnoreList), afterPostCallback, customMessage, true, false, false, onErrorCallback);
  }

  putCompany(id: number, company: Company, afterPutCallback?: Function, customMessage?: string, onErrorCallback?: onErrorCallbackInterface): void {
    return this.putNow('/company/' + id, this.getBody(company, CompanyIgnoreList), afterPutCallback, customMessage, true, false, onErrorCallback);
  }

  startIbanXSOnboarding(id: number, company: Company, afterPostCallback?: Function, customMessage?: string): void {
    return this.postNow(Url.CompanyOnboarding.replace('{companyId}', id.toString()), this.getBody(company, CompanyIgnoreList), afterPostCallback, customMessage);
  }

  deleteCompany(id: number, afterDeleteCallback?: Function, customMessage?: string): void {
    return this.deleteNow('/company/' + id, afterDeleteCallback, customMessage);
  }
}
